var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { getImmersiveWidgetStyles } from './ImmersiveWidgetStyles';
import { BLACK_300, BLACK_400, Button, getTestId, isValidObject, KeyPairUnit } from '@airtel/air-design-system';
import { SectionHeader } from './components/section-header';
import { EngagementRailWidget } from '../engagement-rail-widget';
import { GrowthInventoryListWidget } from '../growth-inventory-widget';
export var ImmersiveWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ImmersiveWidget' : _props$testID,
    style = props.style,
    avatarProps = props.avatarProps,
    titleProps = props.titleProps,
    sectionHeaderStyle = props.sectionHeaderStyle,
    keyUnitProps = props.keyUnitProps,
    buttonProps = props.buttonProps,
    onUserAction = props.onUserAction,
    buttonOnPressMetaData = props.buttonOnPressMetaData,
    engagementRailProps = props.engagementRailProps,
    growthInventoryProps = props.growthInventoryProps,
    additionalGrowthInventoryProps = props.additionalGrowthInventoryProps,
    bottomSectionGrowthInventoryProps = props.bottomSectionGrowthInventoryProps,
    restProps = __rest(props, ["id", "testID", "style", "avatarProps", "titleProps", "sectionHeaderStyle", "keyUnitProps", "buttonProps", "onUserAction", "buttonOnPressMetaData", "engagementRailProps", "growthInventoryProps", "additionalGrowthInventoryProps", "bottomSectionGrowthInventoryProps"]);
  var immersiveWidgetStyles = getImmersiveWidgetStyles();
  return _jsxs(View, Object.assign({}, getTestId(testID), restProps, {
    style: [immersiveWidgetStyles.container, style]
  }, {
    children: [!!isValidObject(growthInventoryProps) && _jsx(GrowthInventoryListWidget, Object.assign({
      imageStyle: immersiveWidgetStyles.growthInventoryImage,
      type: 'inventoryBanner',
      carouselWidgetProps: Object.assign({
        showNavigationCtas: false,
        showIndicators: true,
        showNavigationCounterWithButton: false
      }, growthInventoryProps.carouselWidgetProps)
    }, getTestId(testID, 'GrowthInventoryListWidget'), Object.assign(Object.assign({}, growthInventoryProps), additionalGrowthInventoryProps))), _jsxs(View, Object.assign({
      style: [immersiveWidgetStyles.subContainer]
    }, {
      children: [!!isValidObject(avatarProps) && !!isValidObject(titleProps) && _jsx(SectionHeader, Object.assign({
        avatarProps: avatarProps,
        titleProps: titleProps,
        sectionHeaderStyle: sectionHeaderStyle
      }, getTestId(testID, 'SectionHeaderWidget'))), _jsxs(View, Object.assign({
        style: immersiveWidgetStyles.keyPair
      }, {
        children: [!!isValidObject(keyUnitProps) && _jsx(KeyPairUnit, Object.assign({
          column: 1,
          style: immersiveWidgetStyles.keyPairUnit
        }, keyUnitProps, getTestId(testID, 'KeyPairUnitWidget'))), !!isValidObject(buttonProps) && _jsx(Button, Object.assign({
          titleProps: {
            style: immersiveWidgetStyles.title
          },
          style: immersiveWidgetStyles.button,
          onPress: () => {
            buttonOnPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, buttonOnPressMetaData), {
              buttonProps
            }));
          }
        }, buttonProps, getTestId(testID, 'ButtonWidget')))]
      }))]
    })), !!isValidObject(engagementRailProps) && _jsx(View, Object.assign({
      style: [immersiveWidgetStyles.engagementRailContainer]
    }, {
      children: _jsx(EngagementRailWidget, Object.assign({
        darkMode: true,
        showSectionTitle: true
      }, engagementRailProps, {
        sectionTitleProps: Object.assign({
          isTitleBold: true,
          titleColor: BLACK_300,
          descriptionColor: BLACK_400,
          style: immersiveWidgetStyles.engagementRailSection
        }, engagementRailProps.sectionTitleProps),
        style: [immersiveWidgetStyles.engagementRail, engagementRailProps === null || engagementRailProps === void 0 ? void 0 : engagementRailProps.style]
      }, getTestId(testID, 'EngagementRailWidget')))
    })), !!isValidObject(bottomSectionGrowthInventoryProps) && _jsx(View, Object.assign({
      style: [immersiveWidgetStyles.bottomSectionGrowthInventory]
    }, {
      children: _jsx(GrowthInventoryListWidget, Object.assign({
        type: 'list',
        showSectionTitle: true
      }, bottomSectionGrowthInventoryProps, {
        carouselWidgetProps: {
          showNavigationCounterWithButton: false
        },
        cardSectionTitleProps: Object.assign({
          titleColor: BLACK_300,
          style: immersiveWidgetStyles.growthInventorySection
        }, bottomSectionGrowthInventoryProps.cardSectionTitleProps)
      }, getTestId(testID, 'BottomSectionGrowthInventoryListWidget')))
    }))]
  }));
};
ImmersiveWidgetComponent.genericRendererKey = 'AirImmersiveWidget';